<!-- <template>
	<type-wrapper class="type-E" padding>
		<type-grid row="11">
			<type-text type="title" size="3" v-if="showData.title">{{ showData.title }}</type-text>
			<type-text type="content" size="6" align="center" v-if="showData.content">{{ showData.content }}</type-text>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// 横幅文字说明
	import mixin from '../mixin.js'
	export default {
		name: 'type-E',
		mixins: [ mixin ]
	}
</script>

<style scoped lang="less">
	.type-E{
		color: #000000;
		background-color: #FAFAFA!important;
	}
</style> -->

<template>
    <type-wrapper class="type-E" padding>
        <type-grid row="11">
            <type-text type="title" size="1" v-if="showData.title">{{ showData.title }}</type-text>
            <type-text type="content" size="9" align="center" v-if="showData.content">{{ showData.content }}</type-text>
            
            <!-- Zcal embed section -->
            <div v-if="shouldShowZcal" class="zcal-container">
                <div class="loading-message" v-if="isLoading">
                    Loading calendar...
                </div>
                
                <div 
                    class="zcal-inline-widget" 
                    :key="zcalKey"
                    ref="zcalWidget"
                    v-show="!isLoading"
                >
                    <a :href="`https://zcal.co/i/${showData.subtitle}`" class="fallback-link">
                        {{ zcalLinkText }} - Schedule a meeting
                    </a>
                </div>
                
                <div v-if="hasError" class="error-message">
                    Failed to load calendar. Please 
                    <a :href="`https://zcal.co/i/${showData.subtitle}`" target="_blank" rel="noopener">
                        click here to schedule your meeting
                    </a>
                </div>
            </div>
        </type-grid>
    </type-wrapper>
</template>

<script>
    // 横幅文字说明
    import mixin from '../mixin.js'
    
    export default {
        name: 'type-E',
        mixins: [ mixin ],
        
        data() {
            return {
                shouldShowZcal: false,
                zcalScriptLoaded: false,
                zcalLinkText: '30 Minute Meeting',
                zcalKey: 0,
                isLoading: false,
                hasError: false,
                loadingTimeout: null,
                errorTimeout: null
            }
        },
        
        computed: {
            isValidZcalId() {
                return this.showData.subtitle && 
                       typeof this.showData.subtitle === 'string' && 
                       this.showData.subtitle.length === 8;
            }
        },
        
        watch: {
            'showData.subtitle': {
                handler(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.handleZcalIdChange();
                    }
                },
                immediate: true
            }
        },
        
        mounted() {
            this.handleZcalIdChange();
        },
        
        beforeDestroy() {
            // Clean up timeouts
            if (this.loadingTimeout) {
                clearTimeout(this.loadingTimeout);
            }
            if (this.errorTimeout) {
                clearTimeout(this.errorTimeout);
            }
            this.shouldShowZcal = false;
        },
        
        methods: {
            handleZcalIdChange() {
                // Reset states
                this.isLoading = false;
                this.hasError = false;
                
                if (this.isValidZcalId) {
                    this.initializeZcal();
                } else {
                    this.shouldShowZcal = false;
                    if (this.showData.subtitle && this.showData.subtitle.length !== 8) {
                        console.warn(`Zcal ID must be exactly 8 characters. Received: "${this.showData.subtitle}" (${this.showData.subtitle.length} characters)`);
                    }
                }
            },
            
            async initializeZcal() {
                if (!this.isValidZcalId) {
                    this.shouldShowZcal = false;
                    return;
                }
                
                try {
                    this.shouldShowZcal = true;
                    this.isLoading = true;
                    this.hasError = false;
                    
                    // Force component re-render with new key
                    this.zcalKey++;
                    
                    // Load the Zcal script
                    await this.loadZcalScript();
                    
                    // Wait for DOM update
                    await this.$nextTick();
                    
                    // Initialize the widget
                    this.initializeZcalWidget();
                    
                } catch (error) {
                    console.error('Failed to load Zcal:', error);
                    this.isLoading = false;
                    this.hasError = true;
                }
            },
            
            loadZcalScript() {
                return new Promise((resolve, reject) => {
                    // Check if script is already loaded and working
                    if (this.zcalScriptLoaded && window.ZCal) {
                        resolve();
                        return;
                    }
                    
                    // Check if script tag already exists
                    const existingScript = document.querySelector('script[src*="zcal.co/embed"]');
                    if (existingScript) {
                        if (window.ZCal) {
                            this.zcalScriptLoaded = true;
                            resolve();
                        } else {
                            // Wait for existing script to load
                            existingScript.addEventListener('load', () => {
                                this.zcalScriptLoaded = true;
                                setTimeout(resolve, 500);
                            });
                            existingScript.addEventListener('error', reject);
                        }
                        return;
                    }
                    
                    // Create new script element
                    const script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.async = true;
                    script.src = 'https://static.zcal.co/embed/v1/embed.js';
                    
                    script.addEventListener('load', () => {
                        console.log('Zcal script loaded successfully');
                        this.zcalScriptLoaded = true;
                        // Give zcal time to initialize
                        setTimeout(resolve, 500);
                    });
                    
                    script.addEventListener('error', (error) => {
                        console.error('Failed to load zcal script:', error);
                        reject(new Error('Failed to load Zcal script'));
                    });
                    
                    document.head.appendChild(script);
                });
            },
            
            initializeZcalWidget() {
                // Set loading timeout
                this.loadingTimeout = setTimeout(() => {
                    this.isLoading = false;
                    // Hide fallback link after widget loads
                    if (this.$refs.zcalWidget) {
                        const fallbackLink = this.$refs.zcalWidget.querySelector('.fallback-link');
                        if (fallbackLink) {
                            fallbackLink.style.display = 'none';
                        }
                    }
                }, 3000);
                
                // Set error timeout
                this.errorTimeout = setTimeout(() => {
                    // If still showing loading after 10 seconds, show error
                    if (this.isLoading) {
                        this.isLoading = false;
                        this.hasError = true;
                    }
                }, 10000);
                
                // Try multiple initialization methods
                this.$nextTick(() => {
                    this.tryZcalInitialization();
                });
            },
            
            tryZcalInitialization() {
                // Method 1: Direct ZCal API
                if (window.ZCal) {
                    if (typeof window.ZCal.init === 'function') {
                        window.ZCal.init();
                    }
                    if (typeof window.ZCal.reload === 'function') {
                        window.ZCal.reload();
                    }
                    if (typeof window.ZCal.refresh === 'function') {
                        window.ZCal.refresh();
                    }
                    if (typeof window.ZCal.scanPage === 'function') {
                        window.ZCal.scanPage();
                    }
                }
                
                // Method 2: Trigger DOM events
                setTimeout(() => {
                    const events = ['DOMContentLoaded', 'load', 'zcal-init', 'zcal-reload'];
                    events.forEach(eventName => {
                        const event = new Event(eventName, { bubbles: true, cancelable: true });
                        document.dispatchEvent(event);
                        
                        if (this.$refs.zcalWidget) {
                            this.$refs.zcalWidget.dispatchEvent(event);
                        }
                    });
                }, 100);
                
                // Method 3: Manual widget detection
                setTimeout(() => {
                    const widgets = document.querySelectorAll('.zcal-inline-widget');
                    widgets.forEach(widget => {
                        if (window.ZCal && typeof window.ZCal.initWidget === 'function') {
                            window.ZCal.initWidget(widget);
                        }
                    });
                }, 200);
                
                // Method 4: Force page load event
                setTimeout(() => {
                    const loadEvent = new Event('load', { bubbles: true });
                    window.dispatchEvent(loadEvent);
                }, 300);
                
                // Method 5: Check if widget loaded successfully
                setTimeout(() => {
                    this.checkWidgetLoaded();
                }, 2000);
            },
            
            checkWidgetLoaded() {
                if (this.$refs.zcalWidget) {
                    const iframe = this.$refs.zcalWidget.querySelector('iframe');
                    const zcalContent = this.$refs.zcalWidget.querySelector('[class*="zcal"]');
                    
                    if (iframe || zcalContent) {
                        // Widget loaded successfully
                        this.isLoading = false;
                        this.hasError = false;
                        console.log('Zcal widget loaded successfully');
                    } else {
                        // Widget didn't load, but don't show error yet
                        console.warn('Zcal widget may not have loaded properly');
                    }
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .type-E{
        color: #000000;
        background-color: #FAFAFA!important;
    }
    
    .zcal-container {
        margin-top: 20px;
        width: 100%;
        position: relative;
        
        .loading-message {
            text-align: center;
            padding: 40px 20px;
            color: #666;
            font-size: 16px;
            background: #f9f9f9;
            border-radius: 8px;
            border: 1px solid #e0e0e0;
        }
        
        .error-message {
            text-align: center;
            padding: 20px;
            color: #d32f2f;
            background: #ffebee;
            border-radius: 8px;
            border: 1px solid #ffcdd2;
            
            a {
                color: #1976d2;
                text-decoration: none;
                
                &:hover {
                    text-decoration: underline;
                }
            }
        }
        
        .zcal-inline-widget {
            width: 100%;
            min-height: 600px;
            position: relative;
            
            .fallback-link {
                display: block;
                text-align: center;
                padding: 20px;
                background: #f5f5f5;
                border-radius: 8px;
                text-decoration: none;
                color: #333;
                border: 1px dashed #ccc;
                transition: all 0.3s ease;
                
                &:hover {
                    background: #e9e9e9;
                    border-color: #999;
                }
            }
        }
    }
    
    // Global styles for zcal widgets
    :global(.zcal-inline-widget) {
        iframe {
            width: 100% !important;
            min-height: 600px !important;
            border: none !important;
            border-radius: 8px !important;
        }
        
        // Hide the fallback link when widget loads
        &:has(iframe) .fallback-link {
            display: none !important;
        }
    }
    
    // Additional global styles to ensure proper display
    :global(.zcal-widget-container) {
        width: 100% !important;
        min-height: 600px !important;
    }
    
    :global(.zcal-embed-container) {
        width: 100% !important;
        min-height: 600px !important;
    }
</style>